<h2 class="page-heading" [style.font-size]="fontSize">{{ heading }}</h2>
